import { AVATAR_DONE, REMOVE_AVATAR, SET_AVATAR } from './constants';

/** @param {File} file the picture chosen */
export const setAvatar = (file) => ({ type: SET_AVATAR, payload: { file } });
export const removeAvatar = () => ({ type: REMOVE_AVATAR });
export const avatarDone = () => ({ type: AVATAR_DONE });
